module.exports = __webpack_public_path__ + "static/media/West_Hall-b.d400bfc4.webp";